import { uniqueId } from 'lodash-es';

import {
  ApiCreatePaymentMethodRequest,
  ApiEditPaymentMethodRequest,
  ApiPaymentMethodResponse,
  BankAccountType,
  CreditCardProcessorName,
  PaymentMethodType,
} from 'src/app/core/models';

const paymentMethods: ApiPaymentMethodResponse[] = [
  {
    id: '1111',
    active: true,
    default: true,
    firstName: 'John',
    lastName: 'Smith',
    currency: 'USD',
    address: {
      address1: '200 S 3rd Ave',
      address2: 'Suite 250',
      city: 'Columbus',
      state: 'OH',
      zipCode: '43098',
      country: 'US',
    },
    method: {
      type: PaymentMethodType.CreditCard,
      number: '411111XXXXXX1111',
      expirationMonth: '07', // Two digits
      expirationYear: '2025', // Four digits
      cvv: '123',
      processor: CreditCardProcessorName.Visa,
      healthAccount: true,
    },
  },
  {
    id: '1112',
    active: true,
    default: false,
    firstName: 'John',
    lastName: 'Smith',
    currency: 'USD',
    address: {
      address1: '72nd street',
      city: 'New York',
      state: 'NY',
      zipCode: '10023',
      country: 'US',
    },
    method: {
      type: PaymentMethodType.BankAccount,
      accountNumber: 'XXXX5678',
      routingNumber: '112200439',
      accountType: BankAccountType.Checking, // savings, checking
    },
  },
  {
    id: '1113',
    active: false,
    default: true,
    firstName: 'John',
    lastName: 'Smith',
    currency: 'USD',
    address: {
      address1: '669 Mandalay Ave',
      city: 'Clearwater',
      state: 'FL',
      zipCode: '33767',
      country: 'US',
    },
    method: {
      type: PaymentMethodType.BankAccount,
      accountNumber: 'XXXX1234',
      routingNumber: '112200439',
      accountType: BankAccountType.Savings, // savings, checking
    },
  },
];

export const getPaymentMethods = (): ApiPaymentMethodResponse[] => {
  return paymentMethods;
};

export const editPaymentMethod = (
  urlParams: any,
  body: ApiEditPaymentMethodRequest
): ApiPaymentMethodResponse | null => {
  const paymentMethodId = urlParams?.paymentMethodId;
  const isDefault = body.default;

  if (!paymentMethodId) return null;

  const paymentMethod = paymentMethods.find((o) => o.id === paymentMethodId);

  if (!paymentMethod) return null;

  paymentMethod.default = isDefault;

  if (isDefault) {
    paymentMethods.forEach((pm) => {
      if (pm.id !== paymentMethodId) pm.default = false;
    });
  }

  return paymentMethod;
};

export const createPaymentMethod = (urlParams: any, body: ApiCreatePaymentMethodRequest): ApiPaymentMethodResponse => {
  const newPaymentMethod = {
    id: uniqueId('pm-cr-'),
    active: true,
    ...body,
  };

  if (body.default) {
    paymentMethods.forEach((pm) => (pm.default = false));
  }

  paymentMethods.push(newPaymentMethod);

  return newPaymentMethod;
};
